import { FaLeaf, FaSeedling, FaTree } from 'react-icons/fa6';
import { images } from '../constants';

const pricing = [
    {
        id: 1,
        image: images.plan1,
        icon: <FaSeedling />,
        title: 'Gardening Plan',
        price: 49,
        list: [
            'Basic Garden Maintenance',
            'Planting Assistance',
            'Soil Preparation',
            'Pest Control',
            'Seasonal Plant Care',
        ],
    },
    {  
        id: 2, 
        image: images.plan2,
        icon: <FaTree />,
        title: 'Landscaping Plan',
        price: 69,
        list: [
            'Landscape Design Consultation',
            'Hardscaping Services',
            'Plant Selection and Installation',
            'Irrigation System Installation',
            'Landscape Lighting',
        ],
    },
    {  
        id: 3,
        image: images.plan3,
        icon: <FaLeaf />,
        title: 'Maintenance Plan',
        price: 99,
        list: [
            'Year-Round Maintenance',
            'Lawn Care Services',
            'Garden Cleanup',
            'Fertilization',
            'Weed Control',
        ],
    },
];

export default pricing;